// Landing page Icon
import MembershipIcon from "./membershipIcon.svg";

// footer data
import footerbrand from "./footerBrand.svg";
import footerCustomer from "./footerCustomer.svg";
import footerInstitution from "./footerInstitution.svg";
import footersaved from "./footerSaved.svg";

// success message 
import check from './check.svg';

// offer type active icons
import { ReactComponent as cashbackIcon } from "./activeCashbackIcon.svg";
import { ReactComponent as discountIcon } from "./activeDiscountOfferIcon.svg";
import { ReactComponent as experienceIcon } from "./activeExperienceIcon.svg";
import { ReactComponent as giftCardIcon } from "./activeGiftCardIcon.svg";
import { ReactComponent as membershipIcon } from "./activeMembershipIcon.svg";
import { ReactComponent as AllRewardIcon } from "./allRewardIcon.svg";

// user profile icons
import { ReactComponent as notificationIcon } from "./NotificationIcon.svg";
import { ReactComponent as profileIcon } from "./ProfileTabIcon.svg";
import { ReactComponent as CashbackIcon } from "./activeCashbackIcon.svg";
import { ReactComponent as DiscountIcon } from "./activeDiscountOfferIcon.svg";
import { ReactComponent as ExperienceIcon } from "./activeExperienceIcon.svg";
import { ReactComponent as GiftCardIcon } from "./activeGiftCardIcon.svg";
import { ReactComponent as AccessMembershipIcon } from "./activeMembershipIcon.svg";
import { ReactComponent as orderIcon } from "./orderIcon.svg";
import { ReactComponent as RewardPoint } from "./rewardIconSvg.svg";
import { ReactComponent as savedOfferIcon } from "./savedOffericon.svg";
import { ReactComponent as wishlistIcon } from "./wishlistIcon.svg";

import earnedPoint from "./EarnedPoint.svg";
import redeenPoint from "./RedeemPoint.svg";
import { ReactComponent as RightArrow } from "./Rightarrow.svg";
import deleteCard from "./deleteCard.svg";
import editUser from "./editUser.svg";
import makeDefault from "./makeDefault.svg";
import viewOrder from "./orderHistory.svg";
import profileImage from "./profileIcon.svg";
import rewardPoint from "./rewardIconSvg.svg";

// Reward Listing Icon
import { ReactComponent as ActiveRecordIcon } from "./activeRecordIcon.svg";
import { ReactComponent as CreditCardIcon } from "./creditCardIcon.svg";

import filterSvg from "./filterSvg.svg";
import greetIcon from "./greetIcon.svg";

// Reward Detail Icon
import { ReactComponent as RewardDetailCopyOffer } from "./rewardDetailCopyOffer.svg";
import { ReactComponent as PlusIcon } from "./rewardDetailPlus.svg";
import { ReactComponent as MinusIcon } from "./rewardDetailminus.svg";
import { ReactComponent as UserGeoLocation } from "./userGeoLocation.svg";
import { ReactComponent as WhiteBankcoLogo } from "./whiteBankcoLogo.svg";

import exoeriencesPeople from "./exoeriencesPeople.svg";
import offerNotValid from "./offerNotValid.svg";
import calenderIcon from "./rewardDetailCalander.svg";
import rupeeIcon from "./rewardDetailRupees.svg";
import websiteIcon from "./rewardDetailWebsite.svg";
import brandIcon from "./rewardDetailbrand.svg";
import multipleIcon from "./rewardDetailmultiple.svg";
import rewardPaymentIcon from "./rewardDetailpayment.svg";
import rewardWhatsAppIcon from "./rewardDetailwhatsapp.svg";
import rewardIconSvg from "./rewardIconSvg.svg";
import thingToNoteIcon from "./thingsToNote.svg";
import tncIcon from "./tnc.svg";
import websiteLink from "./websiteLink.svg";

// OrderSummary Icon 
import emailOrderIcon from "./emailOrderIcon.svg";
import phoneOrderIcon from "./phoneOrderIcon.svg";
import profileOrderIcon from "./profileOrderIcon.svg";

// Contact us page Icon
import addressIcon from "./addressIcon.svg";
import emailIcon from "./emailIcon.svg";
import phoneIcon from "./phoneIcon.svg";

// Dropdown Icon
import dropDownArrow from "./downArrow.svg";
import upArrow from "./upArrow.svg";

// Bankco Logo common Icon
import bankco from "./bankcologo.svg";
import offlineIcon from "./offlineTag.svg";
import onlineIcon from "./onlineTag.svg";
import recentSearch from "./recentSearch.svg";

//Header Icon
import menuIcon from "./menuSvg.svg";
import search from "./search.svg";
import support from "./support.svg";

import { ReactComponent as AIIcon } from "./AI.svg";
import { ReactComponent as Laptop } from "./Laptop.svg";
import { ReactComponent as Mobile } from "./Mobile.svg";
import { ReactComponent as Subscription } from "./Subscription.svg";
import { ReactComponent as UPIIcon } from "./UPI.svg";
import { ReactComponent as Download } from "./download.svg";
import { ReactComponent as MastercardIcon } from "./mastercard.svg";
import { ReactComponent as RecentSearchIcon } from "./recentSearch.svg";
import { ReactComponent as SubscriptionDevice } from "./subscriptionDevice.svg";
import { ReactComponent as SubscriptionPayment } from "./subscriptionPayment.svg";
import { ReactComponent as SubscriptionStar } from "./subsriptionStar.svg";
import { ReactComponent as VisaIcon } from "./visaIcon.svg";

// Arrows 
import { ReactComponent as LeftArrowIcon } from "./LeftArrow.svg";
import { ReactComponent as RightArrowIcon } from "./Right arrow.svg";
import { ReactComponent as LongArrowIcon } from "./LongArrow.svg";

import { ReactComponent as FlightExchange } from "./flightExchange.svg";
// import { ReactComponent as DropDownArrow } from "./DropDown.svg";
import { ReactComponent as ArrivalIcon } from "./Arrival.svg";
import { ReactComponent as DepartureIcon } from "./Departure.svg";
import { ReactComponent as Planeicon } from "./planeicon.svg";
import { ReactComponent as ClipboardIcon } from "./Clipboard.svg";

import { ReactComponent as RupeesSymbol } from "./RupeesSymbol.svg";

import { ReactComponent as Twitter } from "./twitter.svg";

import { ReactComponent as AxisSvg } from "./axis.svg";
import { ReactComponent as StarSvg } from "./star.svg";

import { ReactComponent as GiftCardRibbonSvg } from "./GiftCardRibbon.svg";
import { ReactComponent as PreciousMetal } from "./preciousMetal.svg";

export {
    AccessMembershipIcon, ActiveRecordIcon, addressIcon, AIIcon, AllRewardIcon, ArrivalIcon, bankco, brandIcon, calenderIcon,
    cashbackIcon, CashbackIcon, check, CreditCardIcon, deleteCard, DepartureIcon, discountIcon, DiscountIcon, Download, dropDownArrow, 
    exoeriencesPeople, experienceIcon, ExperienceIcon, filterSvg, FlightExchange, footerbrand, footerCustomer, footerInstitution,
    footersaved, giftCardIcon, GiftCardIcon, greetIcon, Laptop, LeftArrowIcon, makeDefault, MastercardIcon,
    membershipIcon, MembershipIcon, menuIcon, MinusIcon, Mobile, multipleIcon, notificationIcon, offerNotValid,
    offlineIcon, onlineIcon, orderIcon, phoneIcon, phoneOrderIcon, Planeicon, PlusIcon, profileIcon, profileImage,
    profileOrderIcon, recentSearch, RecentSearchIcon, redeenPoint, RewardDetailCopyOffer, rewardIconSvg,
    rewardPaymentIcon, RewardPoint, rewardPoint, rewardWhatsAppIcon, RightArrow, RightArrowIcon, rupeeIcon,
    savedOfferIcon, search, Subscription, SubscriptionDevice, SubscriptionPayment, SubscriptionStar, PreciousMetal,
    support, thingToNoteIcon, tncIcon, upArrow, UPIIcon, UserGeoLocation, viewOrder, VisaIcon, websiteIcon, WhiteBankcoLogo,
    websiteLink, wishlistIcon, RupeesSymbol, LongArrowIcon, ClipboardIcon, Twitter, AxisSvg, StarSvg, GiftCardRibbonSvg, earnedPoint, 
    editUser, emailIcon, emailOrderIcon,
};

